import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useSearchParams } from '../../hooks/useSearchParams';
import { jsx as _jsx } from "react/jsx-runtime";
const KEYS_TO_KEEP = ['q', 'sort'];
export function ClearFiltersButton() {
  const params = useSearchParams();
  const handleClick = () => {
    params.keys().forEach(key => {
      if (!KEYS_TO_KEEP.includes(key)) params.delete(key);
    });
  };
  return /*#__PURE__*/_jsx(Button, {
    use: "link",
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceStorefront.filters.clearAll"
    })
  });
}